export type Stage =
  | 'done'
  | 'error'
  | 'idle'
  | 'scoring'
  | 'scraping'
  | 'tailoring';

export const STAGES: { key: Stage; label: string }[] = [
  {
    key: 'scraping',
    label: 'Fetching job posting',
  },
  {
    key: 'scoring',
    label: 'Scoring match',
  },
  {
    key: 'tailoring',
    label: 'Tailoring resume',
  },
  {
    key: 'done',
    label: 'Done',
  },
];
